import type { BadgeTone } from '@/shared/components/ui/Badge';
import type { JobStatus } from './types';

export const WEBSITE_FILTER_OPTIONS = [
  { value: 'no-website', label: 'No website only' },
  { value: 'has-website', label: 'Has website only' },
  { value: 'any', label: 'Any' },
];

// Matches the backend ageFilter whitelist (server.js).
export const AGE_FILTER_OPTIONS = [
  { value: 'any', label: 'Any age' },
  { value: 'new', label: 'New' },
  { value: 'growing', label: 'Growing' },
  { value: 'established', label: 'Established' },
  { value: 'legacy', label: 'Legacy' },
];

export const RATING_OPTIONS = [
  { value: '0', label: 'Any rating' },
  { value: '3', label: '3.0+' },
  { value: '3.5', label: '3.5+' },
  { value: '4', label: '4.0+' },
  { value: '4.5', label: '4.5+' },
];

export const JOB_STATUS_TONES: Record<JobStatus, BadgeTone> = {
  running: 'info',
  completed: 'success',
  stopped: 'warning',
  error: 'danger',
};

export const JOB_STATUS_LABELS: Record<JobStatus, string> = {
  running: 'Running',
  completed: 'Completed',
  stopped: 'Stopped',
  error: 'Error',
};
